module.exports = __webpack_public_path__ + "img/homepage-2.eefa36b4.png";